import type { ReactElement } from 'react'

import { ICONS } from 'const/icons'
import { Body } from 'syf-component-library/ui/typography'
import { NoAccountMessageBox as StyledNoAccountMessageBox } from './NoAccountMessageBox.styles'

interface NoAccountMessageBoxProps {
  /** Copy or text that is to be rendered in the alert box */
  bodyText: string
}

/**
 * Error message box component that renders when a user enters invalid credentials while trying to authenticate
 *
 * @param {NoAccountMessageBoxProps} param0
 * @param {string} param0.bodyText
 * @returns {ReactElement}
 */

const NoAccountFoundMessageBox = ({
  bodyText
}: NoAccountMessageBoxProps): ReactElement => {
  return (
    <StyledNoAccountMessageBox
      type="error"
      icon={ICONS.SOLID_EXCLAMATION_TRIANGLE}
    >
      <Body>{bodyText}</Body>
    </StyledNoAccountMessageBox>
  )
}

export default NoAccountFoundMessageBox
